export default __webpack_public_path__ + "static/media/partners-logo-transys-w.9fc31135.webp";